import Vue from 'vue';

export default {
  namespaced: true,

  // initial state
  state: {
    data: JSON.parse(localStorage.getItem('settings')) || null,
  },

  // getters
  getters: {
    getData(state) {
      return state.data;
    },
    getEventStatuses(state) {
      return state.data ? state.data.event_statuses : null;
    },
    getEventTypes(state) {
      return state.data ? state.data.event_types : null;
    },
    getUserTypes(state) {
      return state.data ? state.data.user_types : null;
    },
  },

  // actions
  actions: {
    get({ commit }, params) {
      return new Promise((resolve, reject) => {
        Vue.axios.get(`/settings`, { params: params })
          .then((response) => {
            commit('setData', response.data);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
  },

  // mutations
  mutations: {
    setData(state, data) {
      localStorage.setItem('settings', JSON.stringify(data));
    },
  },
};
